import * as Sentry from "@sentry/react";

let isSentryInitialized = false;

export const initSentry = (): void => {
  const isLocal = import.meta.env.VITE_APP_ENV === "local";

  if (!isLocal && import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      sendDefaultPii: true,
      enabled: true,
      environment: import.meta.env.VITE_APP_ENV || "unknown",
      release: import.meta.env.VITE_COMMIT_HASH || "unknown",
      enableLogs: true,
      integrations: [Sentry.consoleLoggingIntegration({ levels: ["error"] })],
    } as Sentry.BrowserOptions);
    isSentryInitialized = true;
  } else {
    // eslint-disable-next-line no-console
    console.log(
      "Sentry is disabled in local environment or VITE_SENTRY_DSN is not set.",
    );
  }
};

export const getSessionId = (): string => {
  let id = localStorage.getItem("uiSessionId");

  if (!id) {
    // Generate new ID and set session cookie
    id = crypto.randomUUID();
    localStorage.setItem("uiSessionId", id);
  }
  return id;
};

export const logToSentry = (
  message: string,
  level: "error" | "warn" | "info" = "info",
  meta?: Record<string, unknown>,
): void => {
  if (isSentryInitialized) {
    Sentry.logger[level](message, meta);
  } else {
    // eslint-disable-next-line no-console
    console.log(`Sentry [${level}]: ${message}`, meta || "");
  }
};
